// https://en.wikipedia.org/wiki/ISO_3166-1
export const countryCodesWithIncludedTax = ['US', 'CA'];
export const countryCodesWithClockFormat12 = ['US', 'CA', 'AU', 'NZ', 'PH'];
